import React from 'react';
import { IIcon } from './types';

export default function HidePassword({
  style = {},
  fill = '#CCCCCC',
  width = '2rem',
  height = '1.62rem',
  className = 'hide-password',
  viewBox = '0 0 20 17'
}: IIcon) {
  return (
    <svg
      style={style}
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      className={`svg-icon ${className}`}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.39464 3.12259L6.14451 3.98224C5.904 4.21869 5.6851 4.47717 5.49108 4.7544L4.49171 3.60873C4.78574 3.43105 5.08715 3.26902 5.39464 3.12259ZM3.28618 0.705468L4.71437 2.34273C4.4118 2.49601 4.11507 2.66334 3.82523 2.84469L2.53259 1.36282L3.28618 0.705468ZM13.3627 12.2572L13.9768 12.9611C13.641 13.0948 13.2994 13.2108 12.9534 13.3092L12.5093 12.8C12.8111 12.645 13.0966 12.463 13.3627 12.2572ZM14.8608 15.4958L13.6731 14.1341C14.0102 14.0237 14.3429 13.8975 14.6699 13.7557L15.6144 14.8385L14.8608 15.4958ZM11.5232 13.1909L11.8464 13.5613C7.53249 14.3067 2.82191 12.4162 0.556557 7.90461C1.33929 6.34545 2.41115 5.10203 3.65577 4.17168L4.96957 5.67781C4.66778 6.35854 4.5 7.11203 4.5 7.90462C4.5 10.9422 6.96243 13.4046 10 13.4046C10.5284 13.4046 11.0395 13.33 11.5232 13.1909ZM12.704 11.502C12.4338 11.7055 12.14 11.8792 11.8274 12.0183L6.17293 5.53608C6.35264 5.24636 6.56438 4.97851 6.80327 4.73743L12.704 11.502ZM16.6182 11.4254L15.1751 9.77103C15.3855 9.18775 15.5 8.55909 15.5 7.90462C15.5 4.86706 13.0376 2.40462 10 2.40462C9.60736 2.40462 9.22387 2.44585 8.85378 2.52434L8.55899 2.18639C12.7624 1.62363 17.2486 3.53308 19.4434 7.90463C18.7181 9.34952 17.7452 10.5219 16.6182 11.4254Z"
        fill="black"
        stroke="black"
      />
    </svg>
  );
}
